"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode, MouseEventHandler } from "react";

type FooterSection336sItem = {
    key: Key | null | undefined;
    /** Detected variants: "Our Services" | "Quick Links" */
    h30Text: ReactNode;
    /** Detected variants: "col-xl-3 col-lg-3 col-sm-6" */
    className?: string;
    /** Detected variants: "footer-widget" */
    div0ClassName?: string;
    /** Detected variants: "footer-title" */
    h30ClassName?: string;
    footerMenuItems?: FooterSectionUlsItem[];
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Cataract Evaluation" | "Pediatric Eye Care" | "Lasik Surgery" | "Glaucoma Screening" | "Diabetic Eye Care" | "Home" | "About Us" | "Services & Plans" | "Nurses & Caretakers" | "Contact Us" */
    link0Text: ReactNode;
    /** Detected variants: "#" | "all_routes.home9" | "all_routes.aboutUs" | "all_routes.contactUs" */
    href: string;
};

type FooterSectionSupportsItem = {
    key: Key | null | undefined;
    /** Detected variants: "isax isax-messages-3" | "isax isax-call-calling" */
    className: string;
    /** Detected variants: "info@example.com" | "+1 24565 89856" */
    link0Text: ReactNode;
    /** Detected variants: "mailto:info@example.com" | "tel:+12456589856" */
    href: string;
    /** Detected variants: "General Inquiries" | "Emergency Cases" */
    span0Text: ReactNode;
    /** Detected variants: "support-item" */
    divClassName?: string;
    /** Detected variants: "avatar avatar-lg bg-primary rounded-circle" */
    div0ClassName?: string;
    /** Detected variants: "link" */
    p0ClassName?: string;
    /** Detected variants: "title" */
    span0ClassName?: string;
};

type FooterSectionUls3Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "social-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeNineFooterSectionGeneratedProps = {
    scrollToTop?: MouseEventHandler<HTMLAnchorElement>;
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: FooterSection336sItem) => Partial<ComponentProps<"h3">>);
    divDiv1P0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionSupportsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerDiv0Div0Div0ClassName?: string;
    /** Default: "Ready Discover More? Contact Us Today!" */
    footerDiv0Div0Div0Div0Div0H20H2Text?: ReactNode;
    footerDiv0Div0Div0Div0Div0H20H2Visible?: boolean;
    footerDiv0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "footer-bg" */
    footerDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-one.png" */
    footerDiv0ImageWithBasePath0ImageSrc?: string;
    footerDiv0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "footer-bg" */
    footerDiv0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-img-2.png" */
    footerDiv0ImageWithBasePath1ImageSrc?: string;
    footerDiv0ImageWithBasePath1ImageVisible?: boolean;
    footerDiv0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "footer-bg" */
    footerDiv0ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-13.png" */
    footerDiv0ImageWithBasePath2ImageSrc?: string;
    footerDiv0ImageWithBasePath2ImageVisible?: boolean;
    footerDiv0ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Copyright © 2026 Doccure. All Rights Reserved" */
    footerDiv1Div0Div0Div0P0PText?: ReactNode;
    /** Default: "#" */
    footerDiv1Div0Link0LinkHref?: string;
    footerDiv1Div0Link0LinkVisible?: boolean;
    footerDiv1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "footer-bg" */
    footerImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-img-one.png" */
    footerImageWithBasePath0ImageSrc?: string;
    footerImageWithBasePath0ImageVisible?: boolean;
    footerImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerSectionUls3LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls3Item) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection336s: FooterSection336sItem[];
    footerSectionSupports: FooterSectionSupportsItem[];
    footerSectionUls3: FooterSectionUls3Item[];
    footerSection336sItemWrapper?: (item: FooterSection336sItem, content: ReactNode) => ReactNode;
    footerSection336sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection336sH3Visible?: boolean;
    footerSection336sH3Renderer?: (item: FooterSection336sItem, defaultNode: ReactNode) => ReactNode;
    footerSection336sH3Props?: Partial<ComponentProps<"h3">> | ((item: FooterSection336sItem) => Partial<ComponentProps<"h3">>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionSupportsItemWrapper?: (item: FooterSectionSupportsItem, content: ReactNode) => ReactNode;
    footerSectionSupportsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionSupportsLinkVisible?: boolean;
    footerSectionSupportsLinkRenderer?: (item: FooterSectionSupportsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionSupportsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionSupportsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls3ItemWrapper?: (item: FooterSectionUls3Item, content: ReactNode) => ReactNode;
    footerSectionUls3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls3LinkVisible?: boolean;
    footerSectionUls3LinkRenderer?: (item: FooterSectionUls3Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls3LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls3Item) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeNineFooterSectionGenerated: FC<HomeNineFooterSectionGeneratedProps> = ({
    scrollToTop,
    footerDiv0Div0Div0Div0Div0H20H2Text = "Ready Discover More? Contact Us Today!",
    footerDiv0Div0Div0Div0Div0H20H2Visible,
    footerDiv0Div0Div0Div0Div0H20H2Renderer,
    footerDiv0Div0Div0Div0Div0H20H2Props,
    footerDiv0ImageWithBasePath0ImageAlt = "footer-bg",
    footerDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-bg-one.png",
    footerDiv0ImageWithBasePath0ImageVisible,
    footerDiv0ImageWithBasePath0ImageRenderer,
    footerDiv0ImageWithBasePath0ImageProps,
    footerDiv0ImageWithBasePath1ImageAlt = "footer-bg",
    footerDiv0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/footer-img-2.png",
    footerDiv0ImageWithBasePath1ImageVisible,
    footerDiv0ImageWithBasePath1ImageRenderer,
    footerDiv0ImageWithBasePath1ImageProps,
    footerDiv0ImageWithBasePath2ImageAlt = "footer-bg",
    footerDiv0ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/footer-bg-13.png",
    footerDiv0ImageWithBasePath2ImageVisible,
    footerDiv0ImageWithBasePath2ImageRenderer,
    footerDiv0ImageWithBasePath2ImageProps,
    footerDiv1Div0Div0Div0P0PText = "Copyright © 2026 Doccure. All Rights Reserved",
    footerDiv1Div0Link0LinkHref = "#",
    footerDiv1Div0Link0LinkVisible,
    footerDiv1Div0Link0LinkRenderer,
    footerDiv1Div0Link0LinkProps,
    footerImageWithBasePath0ImageAlt = "footer-bg",
    footerImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-img-one.png",
    footerImageWithBasePath0ImageVisible,
    footerImageWithBasePath0ImageRenderer,
    footerImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    divDiv1P0Link0LinkProps,
    footerSectionUls3LiLink0LinkProps,
    liLink0LinkProps,
    footerDiv0Div0Div0ClassName,
    footerSection336s,
    footerSectionSupports,
    footerSectionUls3,
    footerSection336sItemWrapper,
    footerSection336sRenderer,
    footerSection336sH3Visible,
    footerSection336sH3Renderer,
    footerSection336sH3Props,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
    footerSectionSupportsItemWrapper,
    footerSectionSupportsRenderer,
    footerSectionSupportsLinkVisible,
    footerSectionSupportsLinkRenderer,
    footerSectionSupportsLinkProps,
    footerSectionUls3ItemWrapper,
    footerSectionUls3Renderer,
    footerSectionUls3LinkVisible,
    footerSectionUls3LinkRenderer,
    footerSectionUls3LinkProps,
}) => {
    return (
        <footer className="footer-nine footer">
            {renderNode(footerImageWithBasePath0ImageVisible, footerImageWithBasePath0ImageRenderer, (
                <SmartImage src={footerImageWithBasePath0ImageSrc} alt={footerImageWithBasePath0ImageAlt} className="img-fluid footer-img-one" {...(footerImageWithBasePath0ImageProps ?? {})} />
            ))}
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row g-md-5 g-4"}>
                        <div className="col-xl-6 col-lg-12 col-md-12">
                            <div className="footer-widget footer-about">
                                {renderNode(footerDiv0Div0Div0Div0Div0H20H2Visible, footerDiv0Div0Div0Div0Div0H20H2Renderer, (
                                    <h2 className="title-main" {...(footerDiv0Div0Div0Div0Div0H20H2Props ?? {})}>{footerDiv0Div0Div0Div0Div0H20H2Text}</h2>
                                ))}
                                <div className="about-popup-item border-0 mb-0 pb-0">
                                    {renderCollectionNode(
                                        footerSectionSupports,
                                        (item: FooterSectionSupportsItem) => (
                                            <div className={item.divClassName ?? "support-item"} key={item.key}>
                                                <div className={item.div0ClassName ?? "avatar avatar-lg bg-primary rounded-circle"}>
                                                    <i className={item.className} />
                                                </div>
                                                <div>
                                                    <span className={item.span0ClassName ?? "title"}>{item.span0Text}</span>
                                                    <p className={item.p0ClassName ?? "link"}>
                                                        {renderItemNode(footerSectionSupportsLinkVisible, footerSectionSupportsLinkRenderer, item, (
                                                            <SmartLink href={item.href} {...(typeof footerSectionSupportsLinkProps === "function" ? footerSectionSupportsLinkProps(item) : (footerSectionSupportsLinkProps ?? {}))} {...(typeof divDiv1P0Link0LinkProps === "function" ? divDiv1P0Link0LinkProps(item) : (divDiv1P0Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                        ))}
                                                    </p>
                                                </div>
                                            </div>
                                        ),
                                        footerSectionSupportsItemWrapper,
                                        footerSectionSupportsRenderer
                                    )}
                                </div>
                            </div>
                        </div>
                        {renderCollectionNode(
                            footerSection336s,
                            (item: FooterSection336sItem) => (
                                <div className={item.className ?? "col-xl-3 col-lg-3 col-sm-6"} key={item.key}>
                                    <div className={item.div0ClassName ?? "footer-widget"}>
                                        {renderItemNode(footerSection336sH3Visible, footerSection336sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "footer-title"} {...(typeof footerSection336sH3Props === "function" ? footerSection336sH3Props(item) : (footerSection336sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <ul className="footer-menu">
                                            {renderCollectionNode(
                                                item.footerMenuItems ?? [],
                                                (item: FooterSectionUlsItem) => (
                                                    <li key={item.key}>
                                                        {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                            <SmartLink href={item.href} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                        ))}
                                                    </li>
                                                ),
                                                footerSectionUlsItemWrapper,
                                                footerSectionUlsRenderer
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            ),
                            footerSection336sItemWrapper,
                            footerSection336sRenderer
                        )}
                    </div>
                </div>
                {renderNode(footerDiv0ImageWithBasePath0ImageVisible, footerDiv0ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={footerDiv0ImageWithBasePath0ImageSrc} alt={footerDiv0ImageWithBasePath0ImageAlt} className="img-fluid footer-bg-one" {...(footerDiv0ImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(footerDiv0ImageWithBasePath1ImageVisible, footerDiv0ImageWithBasePath1ImageRenderer, (
                    <SmartImage src={footerDiv0ImageWithBasePath1ImageSrc} alt={footerDiv0ImageWithBasePath1ImageAlt} className="img-fluid footer-bg-two" {...(footerDiv0ImageWithBasePath1ImageProps ?? {})} />
                ))}
                {renderNode(footerDiv0ImageWithBasePath2ImageVisible, footerDiv0ImageWithBasePath2ImageRenderer, (
                    <SmartImage src={footerDiv0ImageWithBasePath2ImageSrc} alt={footerDiv0ImageWithBasePath2ImageAlt} className="img-fluid footer-bg-three" {...(footerDiv0ImageWithBasePath2ImageProps ?? {})} />
                ))}
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="copyright">
                        <div className="copyright-text">
                            <p className="mb-0">{footerDiv1Div0Div0Div0P0PText}</p>
                        </div>
                        <ul className="d-flex align-items-center gap-2 social-icon-list">
                            {renderCollectionNode(
                                footerSectionUls3,
                                (item: FooterSectionUls3Item) => (
                                    <li key={item.key}>
                                        {renderItemNode(footerSectionUls3LinkVisible, footerSectionUls3LinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "social-icon"} {...(typeof footerSectionUls3LinkProps === "function" ? footerSectionUls3LinkProps(item) : (footerSectionUls3LinkProps ?? {}))} {...(typeof footerSectionUls3LiLink0LinkProps === "function" ? footerSectionUls3LiLink0LinkProps(item) : (footerSectionUls3LiLink0LinkProps ?? {}))}>
                                                <i className={item.className} />
                                            </SmartLink>
                                        ))}
                                    </li>
                                ),
                                footerSectionUls3ItemWrapper,
                                footerSectionUls3Renderer
                            )}
                        </ul>
                    </div>
                    {renderNode(footerDiv1Div0Link0LinkVisible, footerDiv1Div0Link0LinkRenderer, (
                        <SmartLink href={footerDiv1Div0Link0LinkHref} className="back-to-top" onClick={scrollToTop} {...(footerDiv1Div0Link0LinkProps ?? {})}>
                            <i className="isax isax-arrow-up-25" />
                            {" "}
                        </SmartLink>
                    ))}
                </div>
            </div>
        </footer>
    );
};

export default HomeNineFooterSectionGenerated;
